import api from './api';

export type LocalTipo = 'ARMAZEM' | 'DEPOSITO' | 'LINHA_PRODUCAO' | 'EXPEDICAO' | 'QUARENTENA' | 'REFUGO' | 'OUTRO';

export interface Local {
  id: string;
  codigo: string;
  descricao: string;
  tipo: LocalTipo;
  capacidade?: number | null;
  unidade_capacidade?: string | null;
  observacoes?: string | null;
  ativo: boolean;
}

export interface LocalInput {
  codigo?: string | null;
  descricao: string;
  tipo: LocalTipo;
  capacidade?: number | null;
  unidade_capacidade?: string | null;
  observacoes?: string | null;
  ativo?: boolean;
}

const ENDPOINT = '/industrializacao/local';

const localService = {
  async listar(filters: { tipo?: string; ativo?: boolean; search?: string } = {}): Promise<Local[]> {
    const response = await api.get<Local[]>(ENDPOINT, { params: filters });
    return response.data;
  },
  async buscarPorId(id: string): Promise<Local> {
    const response = await api.get<Local>(`${ENDPOINT}/${id}`);
    return response.data;
  },
  async criar(data: LocalInput): Promise<Local> {
    const response = await api.post<Local>(ENDPOINT, { ...data, codigo: data.codigo || undefined });
    return response.data;
  },
  async atualizar(id: string, data: Partial<LocalInput>): Promise<Local> {
    const response = await api.put<Local>(`${ENDPOINT}/${id}`, data);
    return response.data;
  },
  async excluir(id: string): Promise<void> {
    await api.delete(`${ENDPOINT}/${id}`);
  },
};

export default localService;
